document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', onCardSwatchChange);
});

function onCardSwatchChange(event) {
  if (!event.target.classList.contains('card-swatch')) return;
  const productHandle = event.target.dataset.productHandle;
  if (!productHandle) return;
  
  // Get the card that contains this specific swatch
  const card = event.target.closest('.card-wrapper.product-card-wrapper');
  if (!card) return;
  
  const variantId = event.target.dataset.variantId;
  if (!variantId) return;
  
  // Store the selected swatch information before the fetch
  const selectedOptionPosition = event.target.dataset.optionPosition;
  const selectedSwatchValue = event.target.dataset.swatchValue;
  const instanceId = event.target.dataset.instanceId || card.dataset.productId;
  
  // Mark this swatch as checked immediately for better visual feedback
  event.target.checked = true;
  
  // Store scroll position to prevent jumping
  const scrollY = window.scrollY;
  
  const sectionId = 'card-product-section';
  const url = `/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;

  fetch(url)
    .then((res) => res.text())
    .then((responseText) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseText, 'text/html');
      const newCardEl = doc.querySelector(`#card-product-${card.dataset.productId}`);
      
      if (newCardEl) {
        // Instead of replacing the entire card, update specific elements
        updateCardElements(card, newCardEl);
        
        // Re-select the swatch after DOM updates
        setTimeout(() => {
          const swatchToSelect = card.querySelector(`.card-swatch[data-option-position="${selectedOptionPosition}"][data-swatch-value="${selectedSwatchValue}"]`);
          if (swatchToSelect) {
            swatchToSelect.checked = true;
          }
          
          // Restore scroll position
          window.scrollTo(0, scrollY);
        }, 10);
      }
    })
    .catch((error) => {
      console.error('Error updating product card:', error);
    });
}

// This function updates only specific elements of the card that need updating
function updateCardElements(currentCard, newCardEl) {
  // Elements to update (add/remove elements as needed for your theme)
  
  // 1. Update product image (but not the swatches)
  const currentImage = currentCard.querySelector('.card__media img');
  const newImage = newCardEl.querySelector('.card__media img');
  if (currentImage && newImage && currentImage.src !== newImage.src) {
    currentImage.src = newImage.src;
    currentImage.srcset = newImage.srcset;
    if (newImage.alt) currentImage.alt = newImage.alt;
  }
  
  // 2. Update price information
  const currentPrice = currentCard.querySelector('.price');
  const newPrice = newCardEl.querySelector('.price');
  if (currentPrice && newPrice && currentPrice.innerHTML !== newPrice.innerHTML) {
    currentPrice.innerHTML = newPrice.innerHTML;
  }
  
  // 3. Update product URL (for "View Product" links)
  const currentLinks = currentCard.querySelectorAll('a[href*="/products/"]');
  const newProductUrl = newCardEl.querySelector('a[href*="/products/"]')?.href;
  if (newProductUrl && currentLinks.length > 0) {
    currentLinks.forEach(link => {
      // Only update the path and query, keep the domain the same
      const currentUrl = new URL(link.href);
      const newUrl = new URL(newProductUrl);
      currentUrl.pathname = newUrl.pathname;
      currentUrl.search = newUrl.search;
      link.href = currentUrl.toString();
    });
  }
  
  // 4. Update availability/badges if they exist
  const currentBadges = currentCard.querySelector('.card__badge');
  const newBadges = newCardEl.querySelector('.card__badge');
  if (currentBadges && newBadges) {
    currentBadges.innerHTML = newBadges.innerHTML;
  }
  
  // 5. Update any quick add buttons data attributes
  const currentQuickAdd = currentCard.querySelector('[data-product-url]');
  const newQuickAdd = newCardEl.querySelector('[data-product-url]');
  if (currentQuickAdd && newQuickAdd) {
    currentQuickAdd.dataset.productUrl = newQuickAdd.dataset.productUrl;
  }
}

function buildCardFetchUrl(productHandle, optionValues, sectionId) {
  const base = `/products/${productHandle}`;
  const params = new URLSearchParams();
  params.set('section_id', sectionId);
  if (optionValues.length > 0) {
    params.set('option_values', optionValues.join(','));
  }
  return `${base}?${params.toString()}`;
}

function getCardOptionValues(card) {
  const fieldsets = card.querySelectorAll('.product-form__input--swatch');
  let chosen = [];
  fieldsets.forEach((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) {
      const pos = parseInt(checked.dataset.optionPosition, 10);
      const val = checked.dataset.swatchValue;
      chosen[pos - 1] = val;
    }
  });
  return chosen.filter((val) => val !== undefined);
}